module.exports = __webpack_public_path__ + "static/img/200213.6cf6b43b.png";